import wx from 'weixin-js-sdk'
export default {
  install (Vue, options) {
    Vue.prototype.wxShare = function () {
      const ACTUUID = this.$route.query.actuuid
      const _this = this
      this.$post('callfee/share', {
        url: window.location.href.split('#')[0],
        actuuid: ACTUUID
      }).then(res => {
        wx.config({
          debug: false,
          appId: res.appId,
          timestamp: res.timestamp,
          nonceStr: res.nonceStr,
          signature: res.signature,
          jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'hideAllNonBaseMenuItem', 'showMenuItems', 'hideMenuItems']
        })
        _this.shareuuid = res.shareuuid
        _this.redirectUrl = res.redirect_url
        _this.recopenid = res.recopenid
        const decodeLink = decodeURIComponent(res.redirect_url)
        const link = `${decodeLink}`
        // console.log(link)
        // const _link = `http://tjzh.rzltech.com/hhr_callfee_front/#/gdindex?actuuid=5512db7fda2d4ab1bc3acfaf9f04284e`
        const shareimgIcon = res.imgurl
        // alert(shareimgIcon)
        const shareDesc = res.desc
        const shareTitle = res.title
        wx.ready(function () {
          wx.hideAllNonBaseMenuItem()
          wx.showMenuItems({
            menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline']
          })
          // 分享朋友圈
          wx.onMenuShareTimeline({
            title: res.title, // 分享标题
            // desc: shareDesc, // 分享描述
            // link: decodeURIComponent(res.redirect_url),
            link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareimgIcon, // 分享图标
            success: function () {
              _this.$toastAuto('分享成功')
            },
            cancel: function () {
              console.log('取消了分享')
            }
          })

          // 发送给朋友
          wx.onMenuShareAppMessage({
            title: shareTitle, // 分享标题
            desc: shareDesc, // 分享描述
            link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareimgIcon, // 分享图标
            type: '', // 分享类型,music、video或link，不填默认为link
            success: function () {
              _this.$toastAuto('分享成功')
            },
            cancel: function () {
              console.log('取消了分享')
            }
          })
        })
      })
      // 分享结束
    }
  }
}



// WEBPACK FOOTER //
// ./src/libs/wechatShare.js